"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createModule = createModule;
exports.createContext = createContext;
exports.createScript = createScript;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _feature = require("../feature");
/**
 * @class VmFeature
 * @extends Feature
 * @classdesc The Feature helper encapsulates any functionality provided by a module, in a stateful object that can be configured and enabled at runtime
 * whenever it is needed by an application.  The @skypager/node runtime is just a collection of features that only make sense in a node process.  A web process
 * could mimic the node feature interface, and swap out direct file access with a rest controller.  A Feature exists to provide a common abstract interface for platform functionality.
 *
 * @example
 *
 *  runtime.feature('vm').enable()
 *
 *  const { exports: exp } = runtime.createModule(`
 *    module.exports = {
 *      hello: 'World'
 *    }
 *  `)
 *
 *   console.log(exp.hello) // => 'World'
 *
 */


var VmFeature =
/*#__PURE__*/
function (_Feature) {
  (0, _inherits2["default"])(VmFeature, _Feature);

  function VmFeature() {
    (0, _classCallCheck2["default"])(this, VmFeature);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VmFeature).apply(this, arguments));
  }

  (0, _createClass2["default"])(VmFeature, [{
    key: "featureWasEnabled",

    /**
     * This makes sure the runtime has a vm property that will work in that environment.  The browser needs vm-browserify to work
     */
    value: function featureWasEnabled() {
      if (this.runtime.isNode) {
        this.runtime.hide('vm', require('vm'));
      } else {
        var vmBrowserify = require('vm-browserify');

        this.runtime.hide('vm', vmBrowserify.createContext ? vmBrowserify : vmBrowserify["default"] || vmBrowserify);
      }
    }
  }], [{
    key: "createCodeRunner",

    /**
     * When the vm is enabled, these methods get mixed into the runtime itself
     */

    /**
     * Creates a function which will asynchronously run a string of code in a given
     * vm context.  By default, that is the sandbox
     *
     * @static
     * @param {*} code
     * @param {Object} [options={}]
     * @param {Object} sandbox
     * @returns {Function}
     * @memberof Runtime
     */
    value: function createCodeRunner(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var sandbox = arguments.length > 2 ? arguments[2] : undefined;
      var vm = this.vm;
      var _options$thisContext = options.thisContext,
          thisContext = _options$thisContext === void 0 ? false : _options$thisContext;
      var hashObject = this.propUtils.hashObject;
      sandbox = sandbox || this.sandbox;
      var vmContext = (vm.isContext ? vm.isContext(sandbox) : false) ? sandbox : !thisContext && vm.createContext(sandbox);
      return (
        /*#__PURE__*/
        (0, _asyncToGenerator2["default"])(
        /*#__PURE__*/
        _regenerator["default"].mark(function _callee() {
          var argv,
              throwErrors,
              script,
              result,
              _args = arguments;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  argv = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                  throwErrors = options.throwErrors || argv.throwErrors;
                  script = typeof code === 'function' ? vm.createScript(code.call(this, (0, _objectSpread2["default"])({
                    displayErrors: true
                  }, options, argv), sandbox), options) : vm.createScript(code, (0, _objectSpread2["default"])({
                    displayErrors: true
                  }, options, argv));
                  _context.prev = 3;
                  result = vmContext ? script.runInContext(vmContext) : thisContext ? script.runInThisContext() : script.runInNewContext(sandbox);
                  return _context.abrupt("return", {
                    result: result,
                    code: code,
                    usedContext: vmContext ? 'vmContext' : thisContext ? 'thisContext' : 'sandboxedContext',
                    hash: hashObject({
                      code: code
                    })
                  });

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context["catch"](3);

                  if (!throwErrors) {
                    _context.next = 12;
                    break;
                  }

                  throw _context.t0;

                case 12:
                  return _context.abrupt("return", {
                    error: {
                      message: _context.t0.message,
                      stack: _context.t0.stack
                    },
                    code: code
                  });

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[3, 8]]);
        }))
      );
    }
    /**
     * Creates a function which will asynchronously evaluate a string of code in the provided context, (i.e. with the object you pass treated as what is in scope in the code)
     */

    /**
     * Creates a module from a string of code.  The string of code will be evaluated with the standard module, module.exports, require, __dirname, __filename being defined,
     * as well as any other global context you provide.  The returned object will have module.exports on it and can be used as normal.
     */

  }]);
  return VmFeature;
}(_feature.Feature);

exports["default"] = VmFeature;
(0, _defineProperty2["default"])(VmFeature, "shortcut", 'vm');
(0, _defineProperty2["default"])(VmFeature, "hostMethods", ['createCodeRunner', 'createModule', 'createScript', 'createContext']);
(0, _defineProperty2["default"])(VmFeature, "createModule", createModule);
(0, _defineProperty2["default"])(VmFeature, "createScript", createScript);
(0, _defineProperty2["default"])(VmFeature, "createContext", createContext);

function createModule(code) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var sandbox = arguments.length > 2 ? arguments[2] : undefined;
  sandbox = sandbox || this.sandbox;
  var wrapped = "(function (exports, require, module, __filename, __dirname) {\n\n".concat(code, "\n\n});");
  var script = this.createScript(wrapped);
  var context = this.vm.isContext(sandbox) ? sandbox : this.createContext(sandbox);
  var hash = this.hashObject({
    code: code
  });
  var filename = options.filename || (this.resolve ? this.resolve("".concat(hash, ".js")) : "".concat(hash, ".js"));
  var id = options.id || filename;
  var dirname = options.dirname || this.cwd || '/';
  var req = options.require || this.get('currentModule.require');
  var parent = options.parent || this.get('currentModule');
  var newModule = {
    id: id,
    children: [],
    parent: parent,
    require: req,
    exports: {},
    loaded: false
  };
  newModule.require = req;

  var moduleLoader = function moduleLoader() {
    return script.runInContext(context)(newModule.exports, newModule.require, newModule, filename, dirname);
  };

  if (options.lazy) {
    return function () {
      var mod = moduleLoader();
      mod.loaded = true;
      mod.parent = parent;
      return mod;
    };
  } else {
    moduleLoader();
    newModule.loaded = true;
    newModule.parent = parent;
    return newModule;
  }
}

function createContext() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return this.vm.createContext((0, _objectSpread2["default"])({}, this.sandbox, options));
}

function createScript() {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new this.vm.Script(code.toString(), options);
}